import { UST_DATABASE, headGallons } from "@/lib/tank";

const GAL = 231;
// Fill-pipe height (cap down to the top of the tank) usually runs 12–36 in; 24 in is typical.
export const RISER = { min: 12, typical: 24, max: 36 };
// Manway lids sit a little in from each end, so the tank is longer than the lid-to-lid distance.
const END_OFFSET_FT = 1.5;

export const lengthFromCapacity = (cap, d, ends) =>
  (Math.max(0, cap - headGallons(d, ends)) * GAL) / (Math.PI * (d / 2) ** 2) + (ends === "dome" ? d : 0);

export const capacityFromDims = (d, lengthIn, ends) =>
  (Math.PI * (d / 2) ** 2 * Math.max(0, lengthIn - (ends === "dome" ? d : 0))) / GAL + headGallons(d, ends);

// Turns a bottom-out stick reading (and optional lid-to-lid distance) into a tank size estimate.
export function measureTank({ bottomIn, riserIn = RISER.typical, spacingFt = 0, ends = "dome" }) {
  const width = bottomIn - riserIn;
  if (!(width >= 30)) return null;
  const range = [Math.max(30, bottomIn - RISER.max), bottomIn - RISER.min];
  const lengthIn = spacingFt > 0 ? (spacingFt + 2 * END_OFFSET_FT) * 12 : null;
  const raw = lengthIn ? capacityFromDims(width, lengthIn, ends) : null;
  const pool = UST_DATABASE.filter((x) => x.ends === ends);
  const ranked = pool.map((x) => {
    const len = lengthFromCapacity(x.capacity, x.diameter, x.ends);
    const dErr = Math.abs(x.diameter - width) / width;
    const lErr = lengthIn ? Math.abs(len - lengthIn) / lengthIn : 0;
    return { ...x, lengthIn: len, score: dErr * 2 + lErr, inRange: x.diameter >= range[0] - 2 && x.diameter <= range[1] + 2 };
  }).sort((a, b) => (b.inRange - a.inRange) || a.score - b.score);
  return { width, range, lengthIn, rawCapacity: raw, matches: ranked.slice(0, 3) };
}

export const ftIn = (inches) => { const r = Math.round(inches); return `${Math.floor(r / 12)} ft ${r % 12} in`; };
